import type { UIMessage } from 'ai'

/**
 * The messages in the stored transcript's order, keeping the chat's own copy of each message it already holds.
 * Messages only the chat holds, such as a reply that failed before it was stored, stay at the end.
 */
export default function mergeStoredMessages<MESSAGE extends UIMessage>(
  current: MESSAGE[],
  stored: MESSAGE[]
): MESSAGE[] {
  const live = new Map(current.map((message) => [message.id, message]))
  const storedIds = new Set(stored.map((message) => message.id))
  if (stored.every((message) => live.has(message.id))) return current
  return [
    ...stored.map((message) => live.get(message.id) ?? message),
    ...current.filter((message) => !storedIds.has(message.id))
  ]
}
